<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13.972 3.21693C13.3292 3.07317 12.669 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.2689 20.9126 10.5484 20.7413 9.84994C20.6098 9.31354 20.0683 8.98534 19.5319 9.11688C18.9955 9.24841 18.6673 9.78987 18.7989 10.3263C18.932 10.8692 19 11.4297 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C12.5219 5 13.0358 5.05695 13.5355 5.16871C14.0745 5.28926 14.6091 4.95006 14.7296 4.41109C14.8502 3.87212 14.511 3.33748 13.972 3.21693Z"
      fill="#636363"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.4038 4.21242L14.8072 6.57247C11.5754 8.71268 9.79503 9.96232 9.34315 10.4142C8.17157 11.5858 8.17157 13.4853 9.34315 14.6569C10.5147 15.8284 12.4142 15.8284 13.5858 14.6569L13.6738 14.5633C14.3644 13.7936 16.3398 10.8874 19.7876 5.59619C20.378 4.69014 19.3099 3.62204 18.4038 4.21242ZM15.4595 8.54053L14.1172 10.5411C13.059 12.1 12.4006 13.0136 12.1716 13.2426C11.781 13.6332 11.1479 13.6332 10.7574 13.2426C10.3668 12.8521 10.3668 12.219 10.7574 11.8284L10.8414 11.7513C11.2518 11.3964 12.5514 10.4843 14.6816 9.05942L15.4595 8.54053Z"
      fill="#636363"
    />
  </svg>
</template>
